import { useTheme } from "@mui/material";
import React from "react";

interface UsersIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export const UsersIcon: React.FC<UsersIconProps> = ({
  size = 24,
  color = undefined,
  ...props
}) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ?? theme.palette.primary.main}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.99 2.99 0 0 0 17.1 7H15c-.8 0-1.54.37-2.01.99l-.69.94c-.26.36-.73.6-1.23.6H8.5c-.83 0-1.5.67-1.5 1.5v1h10.75c.28 0 .5.22.5.5s-.22.5-.5.5H16v2c0 .55.45 1 1 1h4zm-8.75-4.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z"/>
      <path d="M9.5 11c1.38 0 2.5-1.12 2.5-2.5S10.88 6 9.5 6 7 7.12 7 8.5 8.12 11 9.5 11zm0-2c-.83 0-1.5.67-1.5 1.5S8.67 12 9.5 12s1.5-.67 1.5-1.5S10.33 9 9.5 9z"/>
    </svg>
  );
};